<template>
  <div>
    <DefaultApp
      v-if="$store.state.config.template_settings.layout === 'layout-default'"
    ></DefaultApp>
    <OldApp
      v-else-if="$store.state.config.template_settings.layout === 'layout-old'"
    ></OldApp>
    <div v-else>
      <v-app>
        <v-snackbar
          :color="snackbar.color"
          v-model="snackbar.show"
          class="text-center"
        >
          <h3 class="font-weight-light">{{ snackbar.text }}</h3>
          <template v-slot:action="{ attrs }">
            <v-btn icon @click="snackbar.show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <router-view></router-view>
      </v-app>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutSelector",
  components: {
    DefaultApp: () => import("./layouts/layout-default/App"),
    OldApp: () => import("./layouts/layout-old/App")
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "error"
    }
  }),
  computed: {
    snackbarTrigger() {
      return this.$store.state.viewstate.notificationSnackbar.trigger;
    }
  },
  watch: {
    snackbarTrigger: function() {
      let globalSnackbar = this.$store.state.viewstate.notificationSnackbar;
      this.snackbar = {
        show: true,
        text: globalSnackbar.text,
        color: globalSnackbar.color
      };
    }
  }
};
</script>

<style scoped></style>
